module.exports = __webpack_public_path__ + "static/media/400126_01.358de537.png";